import { useMemo } from 'react';
import { useWetagStore, type WetagStore } from '@frontend/shared';

/**
 * @deprecated This hook is deprecated and should not be used in new code. Please see libs/services/wetags/README.md for more information on how to use the new wetags library.
 */
export const useWeTags = (weTag: string) => {
  const weTagSelector = useMemo(() => (state: WetagStore) => state.enabledWeTags[weTag], [weTag]);
  const isWeTagEnabled = useWetagStore(weTagSelector);

  return isWeTagEnabled;
};
